// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__UZ2Kd","container-dark":"Dashboard_container-dark__-9hXT"};